export default __webpack_public_path__ + "static/race-day-marathon-vertical-29b2c9e88c4ff671b257c8973b04f57a.png";